import CodeBlock from "../../../../src/components/CodeBlock";
import * as React from 'react';
export default {
  CodeBlock,
  React
};